import { initBootstrapComponent } from "./utils"

export function init () {
  initBootstrapComponent("tooltip")
}